import React from 'react';
import { Modal, Form, Toast, Input, Button, Swiper } from 'antd-mobile';
import axios from 'axios';
import './index.less'
function MobileNav(props) {

  const headerChangePages = (num) => {
    window.location.href = `${window.location.origin}${window.location.pathname}?flag=${num}`
  }

  const submitForm1 = (data) => axios({
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'post',
    url: '/consumer-zhifubao/aliPay/user/submitUserConsultInfo',
    responseType: 'json',
    data
  })

  const onFinishForm = (values) => {
    submitForm1({
      ...values,
      consultType: 1,
      consultSource: 1,
    }).then(res => {
      if (res?.data?.code === 1) {
        Modal.clear()
        Toast.show({
          icon: 'success',
          content: res.data.msg,
        })
      } else {
        Toast.show({
          icon: 'fail',
          content: res.data.msg,
        })
      }
    });
  };

  const showModal = () => {
    Modal.show({
      content: (
        <div className="mobile-business-modal-content">
          <strong>立即预约</strong>
          <div className="close" onClick={(e) => {
            Modal.clear()
          }}></div>
          <Form layout="horizontal" mode='card' onFinish={onFinishForm} footer={<Button block type="submit" color="danger" style={{ width: '50%', margin: '0 auto' }}>提交</Button>}>
            <div className="form_line">
              <span>姓<div style={{ opacity: '0', display: 'inline' }}>占位</div>名：</span>
              <Form.Item name="contactName" rules={[{ required: true, message: '请输入姓名' }]}>
                <Input placeholder='请输入姓名' />
              </Form.Item>
            </div>
            <div className="form_line">
              <span>企业名称：</span>
              <Form.Item name="enterpriseName" rules={[{ required: true, message: '请输入企业名称' }]}>
                <Input placeholder='请输入企业名称' />
              </Form.Item>
            </div>
            <div className="form_line">
              <span>手机号码：</span>
              <Form.Item name="telephone" rules={[{ required: true, message: '请输入手机号码' }]}>
                <Input placeholder='请输入手机号码' />
              </Form.Item>
            </div>
            <div className="form_line">
              <span>意向类型：</span>
              <Form.Item name="categories">
                <Input placeholder='请输入意向类型' />
              </Form.Item>
            </div>
          </Form>
        </div>
      ),
      closeOnMaskClick: true,
      className: "mobile-business-modal"
    })
  }

  return (
    <div className="fixBox-mobile">
      <div className="box-right">
        <div className="top"></div>
        <div className="box">
          <div className="tip">
            惠租客服
          </div>
        </div>
        <div className="lease">
          <div className="pic"></div>
          <div className="font">我要租赁</div>
          <div className="box-lease">
            <div className="title">立即租赁</div>
            <div className="pic"></div>
            <div className="tip">支付宝扫一扫，立即租赁</div>
          </div>
        </div>
        <div className="wechat">
          <div className="pic"></div>
          <div className="font">微信咨询</div>
          <div className="box-wechat">
            <div className="title">微信咨询</div>
            <div className="tip">0成本快速开启你的租赁店铺</div>
            <div className="pic"></div>
            <div className="content">微信扫一扫，立即咨询开店</div>
          </div>
        </div>
        <div className="phone">
          <div className="pic"></div>
          <div className="font">电话咨询</div>
          <div className="box-phone">
            <div className="bottom">客服热线：<br />0571—26881669<br /><span className='small'>9:30—18:00</span></div>
          </div>
        </div>
        <div className="phone1" onClick={()=>showModal()} >
          <div className="pic"></div>
          <div className="font">商家入驻</div>
        </div>
        <div className="phone2" onClick={()=>headerChangePages(9)} >
          <div className="pic"></div>
          <div className="font">企业定制</div>
        </div>
      </div>
    </div>
  )
}

export default MobileNav;